import { z } from 'zod';
import { AutoArtifactFields } from './auto-artifacts.js';
/** Only accept from an authenticated encrypted event/command, never hosted metadata. */
export const EncryptedArtifactRef = z.strictObject({
    version: z.literal(1),
    accountId: z.string().min(1).max(256),
    epoch: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
    objectId: z.string().min(1).max(256),
    runId: z.string().min(1).max(256),
});
// ---- screen-sweep: encrypted artifact index ----
const Id = z.string().min(1).max(256);
/**
 * The sealed value of one `artifact` entity: what the Artifacts tab lists. Written by the endpoint
 * that uploaded the artifact (vikod's store, or this browser's attachment upload); the relay only
 * sees an opaque entity head.
 */
export const ArtifactIndexEntry = z.object({
    ref: EncryptedArtifactRef,
    /** Poster/thumbnail (video, HTML captures), sealed as its own artifact. */
    thumb: EncryptedArtifactRef.optional(),
    name: z.string().min(1).max(512),
    mime: z.string().min(1).max(255),
    size: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
    runId: Id,
    taskId: Id.optional(),
    projectId: Id.optional(),
    workstreamId: Id.optional(),
    caption: z.string().max(2000).optional(),
    createdAt: z.number().int().nonnegative(),
    // ---- auto-artifacts ----
    ...AutoArtifactFields,
    // ---- end auto-artifacts ----
});
// ---- end screen-sweep ----
//# sourceMappingURL=artifact-ref.js.map